import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';
import './ToastContext.css';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
    return id;
  }, []);

  const success = useCallback((msg) => show(msg, 'success'), [show]);
  const error = useCallback((msg) => show(msg, 'error'), [show]);
  const warning = useCallback((msg) => show(msg, 'warning'), [show]);

  return (
    <ToastContext.Provider value={{ show, success, error, warning }}>
      {children}
      <div className="toast-container" aria-live="polite">
        {toasts.map(t => (
          <Toast key={t.id} message={t.message} type={t.type} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    return {
      success: (msg) => console.log('[toast]', msg),
      error: (msg) => console.error('[toast]', msg),
      warning: (msg) => console.warn('[toast]', msg)
    };
  }
  return ctx;
}
